import { actionPreset, type ActionButtonDef } from '@intelishs-group/ui';

// ── Catálogo global de acciones del sistema ──────────────────────────
// Fuente única: cada acción se define una sola vez.

export const RH_ACTIONS = {
  // ── Acciones comunes ──
  ver: actionPreset('ver', { icon: 'eye', tooltip: 'Ver detalle', color: '#1890ff' }),
  editar: actionPreset('editar', { icon: 'edit', tooltip: 'Editar', color: '#43a047' }),

  // ── Vacaciones: aprobación / rechazo ──
  aprobar: actionPreset('aprobar', { icon: 'check', tooltip: 'Aprobar', color: '#43a047' }),
  rechazar: actionPreset('rechazar', { icon: 'close', tooltip: 'Rechazar', color: '#e53935' }),
  cancelar: actionPreset('cancelar', {
    icon: 'delete',
    tooltip: 'Cancelar solicitud',
    color: '#e53935',
  }),
  resolucion: actionPreset('resolucion', {
    icon: 'eye',
    tooltip: 'Ver resolución',
    color: '#1890ff',
  }),

  // ── Empleados ──
  desactivar: actionPreset('desactivar', { icon: 'stop', tooltip: 'Desactivar', color: '#e53935' }),
  activar: actionPreset('activar', {
    icon: 'check-circle',
    tooltip: 'Reingreso / Activar',
    color: '#43a047',
  }),
  // Naranja, no azul: el azul es el de `ver` y en la fila de empleados los dos
  // botones quedaban pegados leyéndose como el mismo. Naranja tampoco choca con
  // el verde de `editar`, el morado de `documentos` ni el rojo de `desactivar`.
  cambiarArea: actionPreset('cambiarArea', {
    icon: 'apartment',
    tooltip: 'Cambiar Área',
    color: '#fa8c16',
  }),
  // ── Filas de array editables (pagadoras, contactos, estudios del
  //    formulario de empleado). El tooltip lo completa quien las usa, porque
  //    dice el sujeto: "Guardar pagadora", "Eliminar estudio". ──
  guardarFila: actionPreset('guardarFila', { icon: 'save', tooltip: 'Guardar', color: '#43a047' }),
  eliminarFila: actionPreset('eliminarFila', {
    icon: 'delete',
    tooltip: 'Eliminar',
    color: '#e53935',
  }),

  // `reemplazar` y `eliminarArchivo` se fueron: la botonera de la fila de archivo
  // ahora la trae `<intelishs-file-slot>` por omisión, con la misma tríada —azul
  // ver, verde modificar, rojo eliminar— y el mismo criterio de color.

  documentos: actionPreset('documentos', {
    icon: 'file-text',
    tooltip: 'Documentos',
    color: '#722ed1',
  }),
} as const satisfies Record<string, ActionButtonDef>;
